import React from "react";

const fmt = (n, dec = 2) =>
  n != null ? Number(n).toLocaleString("en-US", { maximumFractionDigits: dec }) : "0";

const fmtUsd = (n) => (n != null ? `$${fmt(n)}` : "$0.00");

const Exitdetails = ({ stats, loading }) => {
  const kaiStats = stats?.kaiStats?.[0] || {};
  const rainBurnedData = stats?.rainBurned?.[0] || {};
  const exitCompleted = stats?.exitCompleted?.[0]?.exitCompleted || 0;
  const totalEligible = stats?.totalUsersEligible?.[0]?.totalUsersEligible || 0;
  const usdtToWallet = stats?.sendToWalletTotal?.[0]?.usdtToWallet || 0;
  const walletCounts = stats?.sentToWalletUserCount || [];
  const claimedCount = walletCounts.find((x) => x._id === "claimed_usdt")?.count || 0;
  const bothCount = walletCounts.find((x) => x._id === "both")?.count || 0;
  const pendingCount = totalEligible - exitCompleted;
  const progressPct = totalEligible > 0 ? ((exitCompleted / totalEligible) * 100).toFixed(1) : 0;
  const pendingPct = totalEligible > 0 ? ((pendingCount / totalEligible) * 100).toFixed(1) : 0;

  const dash = loading || !stats ? "—" : null;

  return (
    <div className="exitcards">
      <div className="innercard">
        <div className="cardtop">
          <img src="/assets/kai.svg" alt="cardimg" className="cardimg" />
          <div className="topheadings">
            <p className="cardpara">KAI Sold</p>
            <h6 className="cardhead">
              {dash ?? fmt(kaiStats.kaiReceived, 0)} <span className="token">KAI</span>
            </h6>
          </div>
        </div>
        <div className="lowerdetail">
          <div className="innerdetail">
            <span className="line"></span>
            <h6 className="headdetail">
              <span className="smalltext">via</span> {dash ?? `${fmt(kaiStats.buyerCount, 0)} Buyers`}
            </h6>
          </div>
          <div className="innerdetail">
            <span className="line"></span>
            <h6 className="headdetail">
              {dash ?? fmtUsd(kaiStats.usdtToKai)} <span className="smalltext">USDT used</span>
            </h6>
          </div>
        </div>
      </div>

      <div className="innercard">
        <div className="cardtop">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clipPath="url(#clip0_4241_1461)">
              <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#26A17B" />
              <path fillRule="evenodd" clipRule="evenodd" d="M13.4416 13.0372V13.0357C13.3591 13.0417 12.9338 13.0672 11.9851 13.0672C11.2276 13.0672 10.6943 13.0447 10.5068 13.0357V13.038C7.59085 12.9097 5.41435 12.402 5.41435 11.7945C5.41435 11.1877 7.59085 10.68 10.5068 10.5495V12.5325C10.6973 12.546 11.2433 12.5782 11.9978 12.5782C12.9031 12.5782 13.3568 12.5407 13.4416 12.5332V10.551C16.3516 10.6807 18.5228 11.1885 18.5228 11.7945C18.5228 12.402 16.3516 12.9082 13.4416 13.0372ZM13.4416 10.3447V8.57023H17.5021V5.86423H6.44635V8.57023H10.5068V10.344C7.20685 10.4955 4.7251 11.1495 4.7251 11.9325C4.7251 12.7155 7.20685 13.3687 10.5068 13.521V19.2075H13.4416V13.5195C16.7363 13.368 19.2121 12.7147 19.2121 11.9325C19.2121 11.1502 16.7363 10.497 13.4416 10.3447Z" fill="white" />
            </g>
            <defs>
              <clipPath id="clip0_4241_1461"><rect width="24" height="24" fill="white" /></clipPath>
            </defs>
          </svg>
          <div className="topheadings">
            <p className="cardpara">USDT Used for KAI</p>
            <h6 className="cardhead">{dash ?? fmtUsd(kaiStats.usdtToKai)}</h6>
          </div>
        </div>
        <div className="lowerdetail">
          <div className="innerdetail">
            <span className="line"></span>
            <h6 className="headdetail">
              <span className="smalltext">of</span> {dash ?? fmtUsd(kaiStats.outOfAllusdtToKai)}{" "}
              <span className="smalltext">total</span>
            </h6>
          </div>
        </div>
      </div>

      <div className="innercard">
        <div className="cardtop">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19 7V4C19 3.73478 18.8946 3.48043 18.7071 3.29289C18.5196 3.10536 18.2652 3 18 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5C3 5.53043 3.21071 6.03914 3.58579 6.41421C3.96086 6.78929 4.46957 7 5 7H20C20.2652 7 20.5196 7.10536 20.7071 7.29289C20.8946 7.48043 21 7.73478 21 8V12M21 12H18C17.4696 12 16.9609 12.2107 16.5858 12.5858C16.2107 12.9609 16 13.4696 16 14C16 14.5304 16.2107 15.0391 16.5858 15.4142C16.9609 15.7893 17.4696 16 18 16H21C21.2652 16 21.5196 15.8946 21.7071 15.7071C21.8946 15.5196 22 15.2652 22 15V13C22 12.7348 21.8946 12.4804 21.7071 12.2929C21.5196 12.1054 21.2652 12 21 12Z" stroke="#02171D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H20C20.2652 21 20.5196 20.8946 20.7071 20.7071C20.8946 20.5196 21 20.2652 21 20V16" stroke="#02171D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <div className="topheadings">
            <p className="cardpara">USDT Sent to Wallets</p>
            <h6 className="cardhead">{dash ?? fmtUsd(usdtToWallet)}</h6>
          </div>
        </div>
        <div className="lowerdetail">
          <div className="innerdetail">
            <span className="line"></span>
            <h6 className="headdetail">
              {dash ?? claimedCount} <span className="smalltext">direct claims</span>
            </h6>
          </div>
          <div className="innerdetail">
            <span className="line"></span>
            <h6 className="headdetail">
              {dash ?? bothCount} <span className="smalltext">partial leftovers</span>
            </h6>
          </div>
        </div>
      </div>

      <div className="innercard">
        <div className="cardtop">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 3C12.6667 5.66667 14 7.83333 16 9.5C18 11.1667 19 13 19 15C19 16.8565 18.2625 18.637 16.9497 19.9497C15.637 21.2625 13.8565 22 12 22C10.1435 22 8.36301 21.2625 7.05025 19.9497C5.7375 18.637 5 16.8565 5 15C5 13.9181 5.35089 12.8655 6 12C6 12.663 6.26339 13.2989 6.73223 13.7678C7.20107 14.2366 7.83696 14.5 8.5 14.5C9.16304 14.5 9.79893 14.2366 10.2678 13.7678C10.7366 13.2989 11 12.663 11 12C11 10 9.5 9 9.5 7C9.5 5.66667 10.3333 4.33333 12 3Z" stroke="#021C24" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <div className="topheadings">
            <p className="cardpara">RAIN Burned</p>
            <h6 className="cardhead">
              {dash ?? fmt(rainBurnedData.rainBurned, 2)} <span className="token">RAIN</span>
            </h6>
          </div>
        </div>
        <div className="lowerdetail">
          <div className="innerdetail">
            <span className="line"></span>
            <h6 className="headdetail">
              <span className="smalltext">≈</span> {dash ?? fmtUsd(rainBurnedData.dollarValue)}{" "}
              <span className="smalltext">value</span>
            </h6>
          </div>
          <div className="innerdetail">
            <span className="line"></span>
            <h6 className="headdetail">
              <span className="smalltext">across </span>
              {dash ?? `${fmt(rainBurnedData.exitCount, 0)} exits`}
            </h6>
          </div>
        </div>
      </div>

      <div className="innercard">
        <div className="cardtop">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 19C15 16.7909 12.3137 15 9 15C5.68629 15 3 16.7909 3 19M9 12C6.79086 12 5 10.2091 5 8C5 5.79086 6.79086 4 9 4C11.2091 4 13 5.79086 13 8C13 10.2091 11.2091 12 9 12Z" stroke="#02171D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 11.25C16 12.22 16.75 13 17.67 13H19.55C20.35 13 21 12.32 21 11.47C21 10.56 20.6 10.23 20.01 10.02L17 8.96999C16.41 8.75999 16.01 8.43999 16.01 7.51999C16.01 6.67999 16.66 5.98999 17.46 5.98999H19.34C20.26 5.98999 21.01 6.76999 21.01 7.73999" stroke="#02171D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.5 5V14" stroke="#02171D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <div className="topheadings">
            <p className="cardpara">Exits Completed</p>
            <div className="carddetails">
              <h2 className="eiligiblenumber">
                <span className="boldtext">{dash ?? fmt(exitCompleted, 0)}</span> / {dash ?? `${fmt(totalEligible, 0)} eligible`}
              </h2>
              <div className="progress">
                <div className="progress-bar" style={{ width: `${progressPct}%` }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="innercard">
        <div className="cardtop">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M17 20C17 18.3431 14.7614 17 12 17C9.23858 17 7 18.3431 7 20M21 17.0004C21 15.7702 19.7659 14.7129 18 14.25M3 17.0004C3 15.7702 4.2341 14.7129 6 14.25M18 10.2361C18.6137 9.68679 19 8.8885 19 8C19 6.34315 17.6569 5 16 5C15.2316 5 14.5308 5.28885 14 5.76389M6 10.2361C5.38625 9.68679 5 8.8885 5 8C5 6.34315 6.34315 5 8 5C8.76835 5 9.46924 5.28885 10 5.76389M12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11C15 12.6569 13.6569 14 12 14Z" stroke="#02171D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <div className="topheadings">
            <p className="cardpara">Pending Users</p>
            <h6 className="cardhead">{dash ?? fmt(pendingCount, 0)}</h6>
          </div>
        </div>
        <div className="lowerdetail">
          <div className="innerdetail">
            <span className="line"></span>
            <h6 className="headdetail">
              {dash ?? `${pendingPct}%`} <span className="smalltext">not yet acted</span>
            </h6>
          </div>
          <div className="innerdetail">
            <span className="line"></span>
            <h6 className="headdetail">
              <span className="smalltext">of</span> {dash ?? fmt(totalEligible, 0)}{" "}
              <span className="smalltext">eligible</span>
            </h6>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Exitdetails;
